/* eslint-disable max-len */
import React, { useCallback } from "react";
import { useUrgentVisitStore } from "../../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";
import { TextareaAutosize } from "@mui/material";

export const AdditionalNotesStep = () => {
  const { selectedPets, currentPetIndex, petBookingData, setPetNotes } =
    useUrgentVisitStore();

  const currentPet = selectedPets[currentPetIndex];
  const currentNotes = currentPet ? petBookingData[currentPet.id]?.additionalNotes ?? "" : "";

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (!currentPet) return;
      setPetNotes(currentPet.id, e.target.value);
    },
    [currentPet, setPetNotes],
  );

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="w-full border border-taupe-50 rounded-xl p-4 flex flex-col gap-4">
        <p className="grenette-pro font-semibold text-lg leading-6 text-light-black">
          {`Please provide more information on ${
            selectedPets.length > 1 ?
              `${currentPet?.name}'s` : "your pet's"
          } urgent symptoms to help us prepare for your appointment.`}
        </p>

        <TextareaAutosize
          value={currentNotes}
          onChange={handleChange}
          placeholder={"Let us know here"}
          className="w-full min-h-[160px] border border-taupe-50 rounded-lg p-3
            text-sm text-light-black placeholder-gray-4 resize-none
            focus:outline-none focus:border-gv-yellow transition-colors"
        />

        <p className="text-xs text-black leading-[18px]">
          <span className="text-red-2">*</span>
          {"This is not mandatory step, but it can help our doctors immensely with helping your pet as quickly as possible"}
        </p>
      </div>
    </div>
  );
};
